import banner1 from "./assets/banner1.png";
import banner2 from "./assets/banner2.png";
import banner3 from "./assets/banner3.png";
import banner4 from "./assets/banner4.png";
import banner5 from "./assets/banner5.png";
import banner6 from "./assets/banner6.png";
import banner7 from "./assets/banner7.png";
import banner8 from "./assets/banner8.png";
import banner9 from "./assets/banner9.png";
import banner10 from "./assets/banner10.png";
import banner11 from "./assets/banner11.png";
import banner12 from "./assets/banner12.png";
import banner13 from "./assets/banner13.png";
import banner14 from "./assets/banner14.png";
import banner15 from "./assets/banner15.png";
import banner16 from "./assets/banner16.png";
import banner17 from "./assets/banner17.png";
import banner18 from "./assets/banner18.png";
import banner19 from "./assets/banner19.png";
import logo from "./assets/logo.jpg";
import accomodation from "./assets/accomodation.png";
import leopard from "./assets/leopard.png";
import lions from "./assets/lions.png";
import hotel from "./assets/hotel.png";

export const company = {
  name: "Zanzibar Mission Tours and Safaris Company Limited",
  shortName: "Zanzibar Mission Tours & Safaris",
  tagline: "Personalized journeys across Zanzibar and mainland Tanzania.",
  location: "P.O. Box 1477, Zanzibar, Tanzania",
  website: "[Insert Website]",
  email: "info@zanzibarmissiontour.com",
  phone: "+255 655 109 444",
  logo,
};

export const navigationItems = [
  { label: "Home", item: "home" },
  { label: "About Us", item: "about_us" },
  { label: "Services", item: "services" },
  { label: "Contact", item: "contact_us" },
];

export const heroSlides = [
  {
    image: banner14,
    kicker: "Zanzibar Excursions",
    title: "Discover the best of Zanzibar through expertly planned island excursions.",
    description:
      "From Stone Town and spice farms to sandbanks, forests, and marine adventures, we turn Zanzibar day trips into smooth, memorable experiences guided by local expertise.",
    points: ["Stone Town and cultural tours", "Marine and beach excursions", "Flexible island itineraries"],
    primaryAction: "Explore Excursions",
    primaryItem: "services",
    secondaryAction: "Plan Your Journey",
    secondaryItem: "contact_us",
  },
  {
    image: accomodation,
    kicker: "Zanzibar Accommodation",
    title: "Stay in Zanzibar properties matched to your comfort, style, and budget.",
    description:
      "We arrange beach resorts, boutique stays, family-friendly hotels, and honeymoon escapes with dependable support from arrival to checkout.",
    points: ["Beach resorts and boutique stays", "Budget to luxury options", "Booking support with local guidance"],
    primaryAction: "Find Your Stay",
    primaryItem: "services",
    secondaryAction: "Contact Us",
    secondaryItem: "contact_us",
  },
  {
    image: lions,
    kicker: "Mainland Safaris",
    title: "Step into mainland Tanzania with safari journeys built around wildlife and wonder.",
    description:
      "We organize safari experiences across Serengeti, Ngorongoro, Tarangire, Mikumi, and beyond with reliable logistics, knowledgeable guides, and well-paced itineraries.",
    points: ["Classic northern safari circuits", "Private and group safaris", "Experienced local coordination"],
    primaryAction: "View Safaris",
    primaryItem: "services",
    secondaryAction: "Talk to Our Team",
    secondaryItem: "contact_us",
  },
  {
    image: hotel,
    kicker: "Mainland Accommodation",
    title: "Rest comfortably before, during, or after your mainland adventure.",
    description:
      "We secure convenient city hotels, safari lodges, tented camps, and business-friendly stays that fit your route, expectations, and trip purpose.",
    points: ["City hotels and safari lodges", "Business and leisure stays", "Coordinated with your itinerary"],
    primaryAction: "See Accommodation Options",
    primaryItem: "services",
    secondaryAction: "Learn About Us",
    secondaryItem: "about_us",
  },
];



export const aboutHighlights = [
  { label: "Based in", value: "Zanzibar, Tanzania" },
  { label: "Coverage", value: "Zanzibar and Mainland Tanzania" },
  { label: "Focus", value: "Accommodation, transfers, and guided tours" },
];

export const coreValues = [
  "Customer Excellence",
  "Professional Integrity",
  "Quality Assurance",
  "Innovation",
  "Sustainability",
  "Teamwork",
];

export const operationalStrengths = [
  "Highly trained and licensed tour guides",
  "Modern and well-maintained fleet of vehicles",
  "Strong partnerships with hotels, lodges, and airlines",
  "Customized and flexible travel itineraries",
  "Competitive and transparent pricing",
  "24/7 customer support and assistance",
  "Strong local knowledge and destination expertise",
];

export const whyChooseUs = [
  "Reliability and professionalism from planning to execution",
  "Comprehensive service for accommodation, transfers, and excursions",
  "Customized experiences for individuals, groups, and corporate clients",
  "Safety-first operations and trusted local coordination",
  "Deep knowledge of Zanzibar and mainland Tanzania",
  "Value-driven pricing without compromising quality",
];

export const sustainabilityItems = [
  "Supporting local employment and professional tour guides",
  "Promoting local artisans and cultural heritage",
  "Encouraging eco-friendly and sustainable tourism practices",
  "Supporting conservation efforts in parks and marine ecosystems",
  "Promoting environmental awareness and education",
];

export const zanzibarExcursions = [
  "Stone Town City Tour",
  "Prison Island Tour",
  "Spice Farm Tour",
  "Dolphin Tour at Kizimkazi",
  "Jozani Forest Tour",
  "Nakupenda Sandbank Picnic",
  "Safari Blue Experience",
  "Cultural village and heritage tours",
];

export const mainlandExperiences = [
  "Serengeti National Park",
  "Ngorongoro Crater",
  "Tarangire National Park",
  "Lake Manyara National Park",
  "Mikumi National Park",
  "Ruaha National Park",
  "Nyerere National Park",
  "Mount Kilimanjaro and Mount Meru trekking",
  "Udzungwa Mountains nature trails",
  "Gombe and Mahale chimpanzee experiences",
];

export const galleryImages = [
  banner2,
  banner3,
  banner4,
  banner6,
  banner7,
  banner8,
  banner9,
  banner12,
  banner13,
  banner15,
  banner16,
  banner19,
];

export const aboutGalleryImages = [banner8, lions, banner10, banner14];

export const guestExperiencePillars = [
  {
    title: "Service With Precision",
    description:
      "Every itinerary is handled with close attention to timing, comfort, communication, and the small details that help guests feel cared for throughout the trip.",
  },
  {
    title: "Capability Across Destinations",
    description:
      "Our team confidently manages both Zanzibar holidays and mainland Tanzania programs, making it easy for guests to enjoy a single, well-coordinated journey.",
  },
  {
    title: "Guest Satisfaction First",
    description:
      "We listen carefully, adapt quickly, and personalize recommendations so each traveler receives an experience that feels thoughtful, seamless, and rewarding.",
  },
];

export const contactCards = [
  {
    title: "Head Office",
    body: "P.O. Box 1477, Zanzibar, Tanzania",
  },
  {
    title: "Travel Planning",
    body: "Accommodation, transfers, excursions, safari extensions, and special itineraries.",
  },
  {
    title: "Guest Support",
    body: "We assist you before, during, and after your trip for a smooth experience.",
  },
];

export const backgroundImages = {
  about: banner7,
  contact: banner1,
};
